interface Iprops {
  width: number;
  height: number;
  active: boolean;
}

export const PoolsIcon = ({ width, height, active }: Iprops) => {
  const color = active ? "#811797" : "#7B7B7B";
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {active && (
        <rect
          width={width}
          height={height}
          rx="4"
          transform="matrix(-1 0 0 1 28 0)"
          fill="#DDEDF4"
        />
      )}
      <path
        d="M3.5 9C4.5 7.5 5.5 7.5 6.5 9C7.5 10.5 8.5 10.5 9.5 9C10.5 7.5 11.5 7.5 12.5 9C13.5 10.5 14.5 10.5 15.5 9C16.5 7.5 17.5 7.5 18.5 9C19.5 10.5 20.5 10.5 21.5 9C22.5 7.5 23.5 7.5 24.5 9"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M3.5 15C4.5 13.5 5.5 13.5 6.5 15C7.5 16.5 8.5 16.5 9.5 15C10.5 13.5 11.5 13.5 12.5 15C13.5 16.5 14.5 16.5 15.5 15C16.5 13.5 17.5 13.5 18.5 15C19.5 16.5 20.5 16.5 21.5 15C22.5 13.5 23.5 13.5 24.5 15"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M3.5 21C4.5 19.5 5.5 19.5 6.5 21C7.5 22.5 8.5 22.5 9.5 21C10.5 19.5 11.5 19.5 12.5 21C13.5 22.5 14.5 22.5 15.5 21C16.5 19.5 17.5 19.5 18.5 21C19.5 22.5 20.5 22.5 21.5 21C22.5 19.5 23.5 19.5 24.5 21"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
